import type { FaireProductEntity } from "../../entity_types/product";

export const p_x35tyb7gp9: FaireProductEntity = {
  token: "p_x35tyb7gp9",
  type: "product",
  name: "CMW26729 Scallop Hem Cable Knit Cardigan",
  brandToken: "b_5tcn5zra86",
  brandName: "Camellia",
  imageUrl:
    "https://cdn.faire.com/fastly/53de277dea6c1cbb5dc06187ecb895a5e32aaee718635f9c6f8c3c4eeb86c871.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/232f72cf5f6455dedb153bd5264bb20dde8700498556c802246c5f89f5b19a36.jpeg",
    "https://cdn.faire.com/fastly/7f999f26f032f4d126bf4403864b0c260ab2b8e888d4afec0812c91a53ed72f0.jpeg",
    "https://cdn.faire.com/fastly/db797157174750427b1483a2a2c27bdf33b7b8aeb23aef93cdd886eb64320d03.jpeg",
    "https://cdn.faire.com/fastly/4af2361709c2d457fb2e877ba593517b381be07066bc59f8e60cc3ebddb33dc2.jpeg",
    "https://cdn.faire.com/fastly/72d83d1c62fd482517fb79fcee677adaacd6d3e1449ba06db46d19b02c5598f7.jpeg",
    "https://cdn.faire.com/fastly/4d9603ba26d3b12aaaac505fce3645d40ccdd9a7e538028979975c7c5371bba9.jpeg",
    "https://cdn.faire.com/fastly/31544486ee0405774ec9ed0c66f372bede1d0176cfee59ef0c9a3636a8b157b7.jpeg",
    "https://cdn.faire.com/fastly/2bfccd32f058fd423a2b1787e806cf22f6090ac3f870210c22b5aca9339a5b01.jpeg",
    "https://cdn.faire.com/fastly/53fffec4d36ab36cee67c9b428e3987392c555d4c9dc48f6227f44a254d4cd50.jpeg",
    "https://cdn.faire.com/fastly/0dc3346cfa59ab7558373a94ee74ae7e6c09e05a68e44b2d67416f2d7c725b13.jpeg",
    "https://cdn.faire.com/fastly/8f62900083cf5c1faffa321ae0458d640b4d617bad7bd81806cad43bfda15a26.jpeg",
  ],
  priceDollars: 20.75,
  description:
    'The Scallop Hem Cable Knit Cardigan brings a romantic twist to a classic knit. Crafted with a soft cable pattern and finished with a delicate scalloped hem and neckline, this button-front cardigan offers a cozy yet feminine look. Its pastel hue adds a dreamy touch, perfect for layering over dresses or pairing with high-waisted denim for an effortlessly chic style.\n\nSELF : 65% POLYESTER, 13% NYLON, 13% ACRYLIC, 6% WOOL, 3% SPANDEX\n\nModel is wearing a size S\nModel : 5\'9" - B 32" - W 24" - H 36.5"',
  tags: [],
  msrpDollars: 41.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:06.798Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
